import React from "react";
export const CompareProductButton = ({
  children
}: {
  children: React.ReactNode;
}) => <div style={{
  display: "block"
}} className="btn-container" data-sentry-component="CompareProductButton" data-sentry-source-file="ButtonVariations.tsx">
    {children}
  </div>;
export const ListOutletButton = ({
  width,
  children
}: {
  width: number;
  children: React.ReactNode;
}) => <div className="btn-container" style={width >= 600 ? {} : {
  marginLeft: "-30px"
}} data-sentry-component="ListOutletButton" data-sentry-source-file="ButtonVariations.tsx">
    {children}
  </div>;
export const GridOutletOrQuoteButton = ({
  children
}: {
  children: React.ReactNode;
}) => <div style={{
  padding: "0px"
}} className="btn-container" data-sentry-component="GridOutletOrQuoteButton" data-sentry-source-file="ButtonVariations.tsx">
    {children}
  </div>;
export const ListQuoteButton = ({
  children
}: {
  children: React.ReactNode;
}) => <div style={{
  maxWidth: "150px"
}} className="btn-container" data-sentry-component="ListQuoteButton" data-sentry-source-file="ButtonVariations.tsx">
    {children}
  </div>;
export const CustomizableCarouselButton = ({
  children
}: {
  children: React.ReactNode;
}) => <div style={{
  padding: "0px"
}} className="btn-container" data-sentry-component="CustomizableCarouselButton" data-sentry-source-file="ButtonVariations.tsx">
    {children}
  </div>;
export const DefaultButton = ({
  children
}: {
  children: React.ReactNode;
}) => <div className="btn-container" data-sentry-component="DefaultButton" data-sentry-source-file="ButtonVariations.tsx">{children}</div>;